import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const Wrapper = styled.section`
    padding: ${({ theme }) => `20px ${theme?.pageTemplate?.paddingLeftRight?.xs} 30px;`};
    ${media.smmin`
        padding: ${({ theme }) => `20px ${theme?.pageTemplate?.paddingLeftRight?.xs} 40px;`};
    `}
    ${media.mdmin`
        padding: ${({ theme }) => `25px ${theme?.pageTemplate?.paddingLeftRight?.md} 50px;`};
    `}
    ${media.lgmin`
        padding: ${({ theme }) => `25px ${theme?.pageTemplate?.paddingLeftRight?.lg} 60px;`};
    `}
`;

const Header = styled.div`
    margin: 0 0 15px;
    ${media.mdmin`
        margin: 0 0 30px;
    `}
`;

const PageTemplate = ({
    header,
    body,
}) => {

    return (
        <Wrapper>
            {header && (
                <Header>
                    {header}
                </Header>
            )}
            {body}
        </Wrapper>
    );

};

PageTemplate.propTypes = {
    header: PropTypes.node,
    body: PropTypes.node.isRequired,
};

PageTemplate.defaultProps = {
    header: null,
};
export default PageTemplate;
